(function($) {
    /* CABEÇALHO */
    
    $('.mobile-button .container').on('click', function () {
        
        $('.links').toggleClass('show-menu');
        $('body').toggleClass('no-scroll');
        
        let $count = 1;
        let $tempo = 30;
        
        $('.links a').each(function () {
            let $this = $(this);
            console.log($this.html());
            
            setTimeout(function () {
                $this.toggleClass('show-link');
            }, ($this.hasClass('show-link')?0:1)*$tempo*$count++);
        });
    });
    
    $('#scroll-top').on('click', function () {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
    
    function toggleSearchBox(isVisible) {
        const modal = $('.search-filter')
        const focusableElements = 'button:not(#mobile-search-button), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        
        if(isVisible) {
            $(focusableElements).attr('tabindex', '-1')
            modal.addClass('display')
            setTimeout(() => {
                modal.addClass('show')
                modal.find(focusableElements).attr('tabindex', '0')
                $('search-field').focus()
            }, 25)
        } else {
            $(focusableElements).attr('tabindex', '0')
            modal.find(focusableElements).attr('tabindex', '-1')
            modal.removeClass('show')
            setTimeout(() => {
                modal.removeClass('display')
            }, 150)
        }
    } 
    
    $(window).on('keydown', function(e) {
        if(e.key === 'Escape') {
            toggleSearchBox(false)
        }
    })
    
    $('.search-button').on('click', function() {
        toggleSearchBox(true)
    })
    $('.search-filter').on('click', function(e) {
        e.stopPropagation()
        if (e.target.classList.contains('search-filter')) {
            toggleSearchBox(false)
        }
    })
    
    $( ".close-modal" ).click(function() {
      toggleSearchBox(false);
    });
    
    function toggleFilter() {
        const container = $('.search-edition-container')
        
        container.toggleClass('show')
    }
    
    $('.toggle-filters').on('click', toggleFilter)
    
    // Share buttons
    const shareButtons = document.querySelectorAll('.share-button')
    
    if (shareButtons) {
        shareButtons.forEach(button => {
            button.addEventListener('click', async () => {
                const title = button.dataset.title ? button.dataset.title : 'Jornal O Comércio'
                const text = button.dataset.text ? button.dataset.text : null
                const url = button.dataset.url
                
                const shareBody = {
                    title,
                    url
                }
                
                if (text) shareBody.text = text
                if (url) await navigator.share(shareBody)
            })
        })
    }
}
)(jQuery);